import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { Box, Typography, Container, Paper } from '@mui/material';

const Login = () => {
    const { login } = useAuth();

    const handleSuccess = (credentialResponse) => {
        console.log('Login Success:', credentialResponse);
        // credentialResponse.credential is the ID token
        // In a real app we might decode it to get user info, 
        // passing it to login() stores it in context
        login(credentialResponse.credential, {}); // Passing empty object as user info for now if we don't decode
    };

    const handleError = () => {
        console.log('Login Failed');
    };

    return (
        <Container component="main" maxWidth="xs" sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                    Sign in to Coin Collector
                </Typography>
                <Box sx={{ mt: 1 }}>
                    <GoogleLogin
                        onSuccess={handleSuccess}
                        onError={handleError}
                        useOneTap
                    />
                </Box>
            </Paper>
        </Container>
    );
};

export default Login;
